module.exports = __webpack_public_path__ + "static/media/dumpster.cb2d2ee0.svg";